import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container } from 'react-bootstrap'
import { TestGif } from "../assets/images"

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({

});

class Alertness extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render() {
    return <Fragment>

      <NavbarComp access_token={true} />
      <div className="page-sections">
        <div className='alertness-wrap'>
          <Container>
            <div className='alertness-contents'>
              <h2 className='main-title-style'>YOUR ALERTNESS</h2>
              {!this.props.auth.baseline ? <p>Please now undertake two tests to establish your baseline score</p> : null}
              <div className='alertness-box'>
                <img src={TestGif} />
              </div>
              <h3>INSTRUCTIONS</h3>
              <ol>
                <li>Do the test when you won't be disturbed.</li>
                <li>At the top you will see the word blue or yellow.</li>
                <li>Focus on the <strong>COLOUR of the top word (<span class="bx-blue"></span>/<span class="bx-yellow"></span>)</strong></li>
                <li>Then press one of the boxes below where the <strong>WORD</strong> (BLUE / YELLOW) describes the Colour of the top word.</li>
                <li>Try to complete as many correct answers as possible.</li>
              </ol>
              {!this.props.auth.baseline ? <div className='alertness-text-bg-blue'>
                TO ESTABLISH YOUR BASELINE ALERTNESS LEVEL, YOU WILL DO THE TEST TWICE. IT WILL TAKE NO MORE THAN 2–3 MINUTES.
              </div> : null}
              <div className='onboarding-back-next-btns'>
                {this.props.auth.baseline ? <a href={this.props.auth.user !== null ? '/dashboard' : "/login"} rel="nofollow"><button className='back-btn'>Back</button></a> :
                  <button className='back-btn onboarding-back-next-disabled' disabled>Back</button>
                }
                <a href='/alertness-test' rel="nofollow"><button className='back-btn'>Next</button></a>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <FooterComp />
    </Fragment>
  }
}

Alertness.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Alertness);
